'use client';

import { Box, VStack } from '@terra/ui-styled-system';
import { InlineToolExpand } from './InlineToolExpand';
import type { ConsolidationSurface } from './chat-message-list-consolidation';
import { headlineKindForSurface } from './chat-headline-actions';
import { useHeadlineCopy } from './chat-headline-copy';

type ConsolidatedToolGroupProps = {
  childContent: React.ReactNode[];
  summary?: string;
  isRunning: boolean;
  surface?: ConsolidationSurface;
  expansionKey?: string;
};

export function ConsolidatedToolGroup({
  childContent,
  summary,
  isRunning,
  surface = 'explored',
  expansionKey,
}: ConsolidatedToolGroupProps) {
  const headlineKind = headlineKindForSurface(surface);
  const copy = useHeadlineCopy(headlineKind);

  if (childContent.length === 0) {
    return null;
  }

  const nestedContent = (
    <Box pr={2} width="100%">
      <VStack alignItems="stretch" gap="6px" width="100%">
        {childContent}
      </VStack>
    </Box>
  );

  return (
    <InlineToolExpand
      toolName="__consolidated__"
      displayText={isRunning ? copy.running : copy.done}
      status={isRunning ? 'in-progress' : 'completed'}
      summary={summary}
      nestedContent={nestedContent}
      expansionKey={expansionKey}
      headlineKind={headlineKind}
    />
  );
}
